import React, { useEffect, useState } from "react";
import Card from "components/card";
import { Form, Input, Select } from 'antd';
import FormItem from "components/fields/FormItem";
import { connect } from "react-redux";
import { useForm } from 'antd/lib/form/Form';
import { requiredField } from '../../../../utils/crudSagaHelper';
import CrudButtons from "components/button/crudbuttons";
import { MONTH_OPTIONS, MODULE_INVOICES } from "variables/constants";
import { getClientList } from "../../../../redux/optionlist/optionlistState";
import { doGenerateMonthlyInvoice } from "../../../../redux/invoice/invoiceState";

const MonthlyInvoiceForm = ({getClientOptions, doGenerateInvoice, recordList = []}) => {
	
  	const [form] = useForm();
	const [clientDropdownOpen, setClientDropdownOpen] = useState(false);
  	
  	useEffect(() => {
        getClientOptions({asOptions: 1, for_invoice: 1});
	}, [getClientOptions]);

	const selectedClients = Form.useWatch('client_ids', form);

	const clientOptions = [
		{
			value: 'all',
			label: 'All Clients',
		},
		...(recordList || []).map(client => ({
			...client,
			disabled: selectedClients?.includes('all'),
		})),
	];

	const handleClientChange = (values) => {
		if (values.includes('all')) {
			form.setFieldsValue({
				client_ids: ['all'],
			});

    		setTimeout(() => setClientDropdownOpen(false), 0);
		}
		};
	
  	const onSubmit = (formData) => {	
    	try {  		
			console.log(formData);	
			doGenerateInvoice(formData);
    	} catch (error) {
      		console.error('Generate failed:', error);
    	}
  	};

  	return (
    	<Card extra={"w-full h-full p-4"}>
		  	<Form form={form} className="p-4 bg-white rounded-md dark:bg-intsamis-900"
		  		layout="vertical"
		  		onFinish={onSubmit}
	        >   
				<h2 className="font-medium text-[18px] mb-4">Generate Client's Monthly Invoice</h2>
        		<div className="grid grid-cols-1 md:grid-cols-4 gap-4"> 
					<FormItem 
		            	name="month"
		                label="Month"
						rules={[requiredField()]}
		            >
		            	<Select 
							id="month"
							className="input-field"
		            		options={MONTH_OPTIONS}
		            	/>
	            	</FormItem>
					<FormItem extra="col-span-1 md:col-span-3"
		            	name="client_ids"
		                label="Client"
						rules={[requiredField()]}
		            >
		            	<Select 
							id="client_ids"
							mode="multiple"
							className="input-field"
		            		options={clientOptions}
							allowClear
							showSearch
							open={clientDropdownOpen}
  							onOpenChange={setClientDropdownOpen}
							onChange={handleClientChange}

		            	/>
	            	</FormItem>  
	 			</div>		
				<CrudButtons 
					baseRoute="/console/invoices" 
					mode="edit" 
					recordId={0} 
					submitLabel="Generate"
					moduleId={MODULE_INVOICES}
				/> 			
	 		</Form>	 	
	 	</Card>
  	);
};

const mapStateToProps = (state) => ({
	recordList: state.optionlist.clientList?.items || [],
});

const mapDispatchToProps = (dispatch) => ({
	getClientOptions: (filters) => dispatch(getClientList(filters)),
	doGenerateInvoice: (data) => dispatch(doGenerateMonthlyInvoice(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MonthlyInvoiceForm);
